var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Util } from '../global';
import { ObjectExt } from '../util';
import { NodeView } from '../view';
import { Edge as StandardEdge } from '../shape/standard/edge';
export var Options;
(function (Options) {
    function parseOptionGroup(graph, arg, options) {
        const result = {};
        Object.keys(options || {}).forEach((key) => {
            const val = options[key];
            result[key] = typeof val === 'function' ? val.call(graph, arg) : val;
        });
        return result;
    }
    Options.parseOptionGroup = parseOptionGroup;
})(Options || (Options = {}));
(function (Options) {
    function merge(options) {
        const { grid, selecting, embedding, snapline, resizing, rotating, clipboard, history, scroller, minimap, keyboard, mousewheel } = options, others = __rest(options, ["grid", "selecting", "embedding", "snapline", "resizing", "rotating", "clipboard", "history", "scroller", "minimap", "keyboard", "mousewheel"]);
        const booleas = [
            'selecting',
            'embedding',
            'snapline',
            'resizing',
            'rotating',
            'clipboard',
            'history',
            'scroller',
            'minimap',
            'keyboard',
            'mousewheel',
        ];
        const container = options.container;
        if (container) {
            if (others.width == null) {
                others.width = container.clientWidth;
            }
            if (others.height == null) {
                others.height = container.clientHeight;
            }
        }
        const result = ObjectExt.merge({}, Options.defaults, others);
        const defaultGrid = { size: 10, visible: false };
        if (typeof grid === 'number') {
            result.grid = { size: grid, visible: false };
        }
        else if (typeof grid === 'boolean') {
            result.grid = Object.assign(Object.assign({}, defaultGrid), { visible: grid });
        }
        else {
            result.grid = Object.assign(Object.assign({}, defaultGrid), grid);
        }
        booleas.forEach((key) => {
            const val = options[key];
            if (typeof val === 'boolean') {
                result[key].enabled = val;
            }
            else {
                result[key] = Object.assign(Object.assign({}, result[key]), val);
            }
        });
        return result;
    }
    Options.merge = merge;
})(Options || (Options = {}));
(function (Options) {
    Options.defaults = {
        x: 0,
        y: 0,
        grid: {
            size: 10,
            visible: false,
        },
        scaling: {
            min: 0.01,
            max: 16,
        },
        background: false,
        highlighting: {
            default: {
                name: 'stroke',
                args: {
                    padding: 3,
                },
            },
            nodeAvailable: {
                name: 'className',
                args: {
                    className: Util.prefix('available-node'),
                },
            },
            magnetAvailable: {
                name: 'className',
                args: {
                    className: Util.prefix('available-magnet'),
                },
            },
        },
        connecting: {
            snap: false,
            multi: true,
            dangling: true,
            highlight: false,
            strategy: null,
            router: 'normal',
            connector: 'normal',
            anchor: 'center',
            edgeAnchor: 'connectionRatio',
            connectionPoint: 'boundary',
            validateConnection(sourceView, sourceMagnet, targetView, targetMagnet, terminalType, edgeView) {
                const view = terminalType === 'target' ? targetView : sourceView;
                return view instanceof NodeView;
            },
            createEdge() {
                return new StandardEdge();
            },
        },
        transforming: {
            clearAll: true,
            clearOnBlankMouseDown: true,
        },
        resizing: {
            enabled: false,
            minWidth: 0,
            minHeight: 0,
            maxWidth: Number.MAX_SAFE_INTEGER,
            maxHeight: Number.MAX_SAFE_INTEGER,
            orthogonal: true,
            preserveAspectRatio: false,
        },
        rotating: {
            enabled: false,
            grid: 15,
        },
        translating: {
            restrict: false,
        },
        embedding: {
            enabled: false,
            findParent: 'bbox',
            frontOnly: true,
            validate: () => true,
        },
        selecting: {
            enabled: false,
            rubberband: false,
            multiple: true,
            movable: true,
            strict: false,
            useCellBBox: false,
            content: null,
            handles: null,
        },
        snapline: {
            enabled: false,
        },
        clipboard: {
            enabled: false,
        },
        history: {
            enabled: false,
        },
        scroller: {
            enabled: false,
        },
        keyboard: {
            enabled: false,
        },
        mousewheel: {
            enabled: false,
            factor: 1.2,
            zoomAtMousePosition: true,
        },
        async: false,
        frozen: false,
        sorting: 'exact',
        moveThreshold: 0,
        clickThreshold: 0,
        magnetThreshold: 0,
        preventDefaultContextMenu: true,
        preventDefaultBlankAction: true,
        interactive: {
            labelMove: false,
        },
        guard: () => false,
    };
})(Options || (Options = {}));
//# sourceMappingURL=options.js.map